import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from "@mui/material/Typography";
import LineChart from "./LineChart";
import BulletChart from "./BulletChart";
import TicketsAddressedTable from "./TicketsAddressedTable";
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React, {useEffect, useState, useCallback} from "react";
import {getClientServiceRequestsDetailsByClientIDAndServiceRequestID} from "../../utilities/ClientApi";
import {Table, TextField} from "@mui/material";
import keycloak from "../../Keycloak";
import {clientId, serviceRequestId} from "../General/Header";
import HoursByTaskCategoryBar from "./HoursByTaskCategoryBar";
import HoursByTeamMemberBar from "./HoursByTeamMemberBar";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";

export let selectedFilterTypeValue = 0;
let renderLegend = true;


const ServiceRequestDashboard = () => {

    const datePeriods = [
        {
            value: `0`,
            label: `Current Month`
        }
    ]
    const cardStyle = {
        borderRadius: 15,
    };

    const [selectedFilterType, setSelectedFilterType] = useState(0);
    const handleChange = (event) => {
        selectedFilterTypeValue = parseInt(event.target.value, 10);
        setSelectedFilterType(selectedFilterTypeValue);
        console.log("SelectedfFilterType " + selectedFilterType);
    }

    const [clientServiceRequestDetails, setClientServiceRequestDetails] = useState([]);

    const callServiceRequestData = useCallback(() => {
        getClientServiceRequestsDetailsByClientIDAndServiceRequestID(clientId, serviceRequestId, keycloak.token)
            .then((clientServiceRequest) => {
                setClientServiceRequestDetails(clientServiceRequest);
            })
            .catch((e) => {
                console.log(e.message)
            })
    }, []);

    useEffect(() => {
        callServiceRequestData();
    }, [callServiceRequestData]);

    const style = {
        "& label.Mui-focused": {
            color: "#EC8D2B",
        },
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#EC8D2B",
            },
        },
        '&:hover .MuiInput-underline:before': {
            borderBottomColor: '#EC8D2B', // Orange underline on hover
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#EC8D2B', // Underline when focused
        },
    };

    const DisplayHours = () => (
        clientServiceRequestDetails.map((data) =>
            data.serviceRequestBudgetSummaryList.map((serviceRequest) => (
                <Grid container direction={"row"} justifyContent={"center"} alignItems={"center"} spacing={2}
                      key={serviceRequest.serviceRequestId}
                      className="hoursCardContainer">
                    {/*<Grid item xs={0.35}/>*/}
                    <Grid item xs={12} sm={2.4}>
                        <Card className={"hoursCard1"} style={cardStyle}>
                            <CardContent>
                                <span className="cardFont">{serviceRequest.allocatedBudget}</span>
                                <span className="cardFont">hrs</span>
                                <Typography className="typographyFontSize">Allocated hours</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={2.4}>
                        <Card className={"hoursCard2"} style={cardStyle}>
                            <CardContent>
                                <span className="cardFont">{serviceRequest.budgetRemaining}</span>
                                <span className="cardFont">hrs</span>
                                <Typography className="typographyFontSize">Budget available</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={2.4}>
                        <Card className={"hoursCard3"} style={cardStyle}>
                            <CardContent>
                                <span className="cardFont">{serviceRequest.budgetUsed}</span>
                                <span className="cardFont">hrs</span>
                                <Typography className="typographyFontSize">Budget spent</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={2.4}>
                        <Card className={"hoursCard4"} style={cardStyle}>
                            <CardContent sx={{align: 'center'}}>
                                <span className="cardFont">{serviceRequest.budgetRemaining}</span>
                                <span className="cardFont">hrs</span>
                                <Typography className="typographyFontSize">Budget remaining</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={2.4}>
                        <Card className={"hoursCard5"} style={cardStyle}>
                            <CardContent>
                                <span className="cardFont">{serviceRequest.daysLeft}</span>
                                <Typography className="typographyFontSize">Days left in period</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            ))
        )
    );

    const styling = () => {
        if(window.location.href.includes("/ServiceRequestList")) {
            return {
                borderRadius: 0,
                boxShadow: false
            };
        }
        else {
            return {
                borderRadius: 15,
            };
        }

    }

    return (
        <div className={"serviceRequestDashboard"}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={8}>
                    <h1 data-testid={"ServiceRequestHeading"} className={"serviceRequestHeading"} style={{fontFamily: 'Poppins'}}>{<IconButton
                        href="/ServiceRequestList" type="button" sx={{p: '5px'}} aria-label="search">
                        <ArrowBackIcon/>
                    </IconButton>}Service Request Dashboard</h1>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextField
                        id="date-period"
                        select
                        label="Date Period"
                        defaultValue={datePeriods[0].value}
                        onChange={handleChange}
                        sx={style}
                        className="datePeriodDropdown"
                        variant="standard"
                    >
                        {datePeriods.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    {DisplayHours()}
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                    <LineChart/>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                    <div data-testid={"ChartComponent"}>
                    {clientServiceRequestDetails.map((data) =>

                        data.serviceRequestBudgetSummaryList.map((serviceRequest) => (
                            serviceRequest.fixedFee === false || true ? (
                                <Card style={styling()} id={'horizontalBar'} className={renderLegend ? "hoursGaugeCard" : ""} data-testid={"GaugeChart"} justifyContent={"center"} >
                                    <CardContent sx={{ fontWeight: 'bold', textAlign: 'center' }}>{renderLegend ? "Total Hours Used" : ""}</CardContent>
                                <BulletChart chartType={'Fat'} projectType={serviceRequest.type} serviceRequestInfo={serviceRequest}/>
                                </Card>
                            ) : (
                                <Card style={styling()} id={'horizontalBar'} className={renderLegend ? "hoursGaugeCard" : ""} data-testid={"GaugeChart"} justifyContent={"center"} >
                                    <CardContent sx={{ fontWeight: 'bold', textAlign: 'center' }}>{renderLegend ? "Total Hours Used" : ""}</CardContent>
                                <BulletChart chartType={'Fat'} projectType={serviceRequest.type} serviceRequestInfo={serviceRequest}/>
                                </Card>
                            )
                        ))
                    )}
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <Table data-testid={"TicketsAddressedTable"}>
                        <TicketsAddressedTable serviceRequestId={serviceRequestId}/>
                    </Table>
                </Grid>
                <Grid item xs={12} md={6}>
                    <div data-testid={"HoursByTaskCategoryBar"}>
                        <HoursByTaskCategoryBar serviceRequestId={serviceRequestId}/>
                    </div>
                </Grid>
                <Grid item xs={12} md={6}>
                    <div data-testid={"HoursByTeamMemberBar"}>
                        <HoursByTeamMemberBar serviceRequestId={serviceRequestId}/>
                    </div>
                </Grid>

            </Grid>


        </div>
    );
};
export default ServiceRequestDashboard